import { useRecoilCallback } from 'recoil';
export const useSetServiceStale = ({ serviceState, }) => {
    const refetch = useRecoilCallback(({ set }) => () => {
        set(serviceState.stale, `${new Date().valueOf()}`);
    }, [serviceState.stale]);
    return refetch;
};
export default useSetServiceStale;
//# sourceMappingURL=use-set-service-stale.js.map